__turbopack_context__.v({
  "active": "SjeI8q_active",
  "arrow": "SjeI8q_arrow",
  "ellipsis": "SjeI8q_ellipsis",
  "pageButton": "SjeI8q_pageButton",
  "pages": "SjeI8q_pages",
  "pagination": "SjeI8q_pagination",
});
